<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'userList' }">Users</el-breadcrumb-item>
      <el-breadcrumb-item
        :to="{ name: 'userShow', params: { id: model.id } }"
        v-if="model"
      >{{ model.email }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">User {{$t('table.history')}}</h2>

    <el-form @submit.native.prevent class="search" :inline="true">
      <el-form-item>
        <el-input v-model="pager.search" :placeholder="$t('table.search')">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <el-table
      :data="pager.paginate(list)"
      :default-sort="{
        prop: 'modified',
        order: 'descending'
      }"
      empty-text="There is no history yet"
      @sort-change="(args) => pager.sortChange(args)"
      style="width: 100%"
      v-loading="loading"
      border
    >
      <el-table-column prop="modified" label="Updated at" width="180" sortable="custom">
        <template slot-scope="scope">{{ scope.row.modified | formatDatetime }}</template>
      </el-table-column>

      <el-table-column label="Updated by" prop="modifiedBy.email" sortable="custom"></el-table-column>

      <el-table-column prop="email" label="Email" sortable="custom"></el-table-column>

      <el-table-column prop="roles" label="Roles">
        <template slot-scope="scope">
          <div v-for="role in scope.row.roles" :key="role">{{ roleLabel(role) }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="created" label="Created at" width="180" sortable="custom">
        <template slot-scope="scope">{{ scope.row.created | formatDatetime }}</template>
      </el-table-column>

      <el-table-column label="Created by" prop="createdBy.email" sortable="custom"></el-table-column>
    </el-table>

    <div class="mt-3">
      <el-pagination
        style="float: right"
        @size-change="(args) => pager.pageSizeChange(args)"
        :current-page.sync="pager.currentPage"
        :layout="paginationLayout"
        :total="pager.filteredAndSortedList(list).length"
        background
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Roles from "@/auth/roles";

export default {
  name: "app-user-history-single",

  props: {
    id: String
  },

  computed: {
    ...mapGetters({
      loading: "user/historySingle/loading",
      list: "user/historySingle/list",
      pager: "user/historySingle/pager",
      model: "user/historySingle/model",
      paginationLayout: "shared/paginationLayout"
    })
  },

  methods: {
    roleLabel(roleId) {
      return Roles.labelOf(roleId);
    }
  },

  created() {
    this.$store.dispatch("user/historySingle/setup", this.id);
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("user/historySingle/clear");
    next();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/user/user-history/user-history-single/user-history-single.vue?bf10c8fc